var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 74,
    viewBox: "0 0 100 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 74,
    rx: 3,
    fill: "#888FA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0442 38.8428C42.212 38.8428 43.3167 39.1766 44.232 39.7646V26.8605V24H47.0726H62.1594H65V26.8605V44.9135C65 48.2825 62.3014 51 58.9716 51C55.6418 51 52.9274 48.2825 52.9274 44.9135C52.9274 41.5603 55.6418 38.8428 58.9716 38.8428C60.1394 38.8428 61.2441 39.1766 62.1594 39.7646V26.8605H47.0726V44.9135C47.0726 48.2825 44.374 51 41.0442 51C37.7144 51 35 48.2825 35 44.9135C35 41.5603 37.7144 38.8428 41.0442 38.8428V38.8428Z",
    fill: "#CDD1DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPreview);
export default __webpack_public_path__ + "static/media/audio-preview.d0db4061a6c94811e3b2d570b07be9b0.svg";
export { ForwardRef as ReactComponent };